<ng-container *ngIf="displayedMessages$ | async as list">
    <div class="notify-base-container">
        @for (item of list; track item.message; let index = $index) {
            <div
                [@notifyItem]
                class="notify light"
                [class.error]="item.type === 'error'"
                [class.success]="item.type === 'success'"
                [class.warning]="item.type === 'warning'"
            >
                @if (item.withAlertIcon) {
                    <div class="notify-icon-container mr-12">
                        @if (item.type === "error") {
                            <mat-icon class="hint-icon" svgIcon="simple_error_hint"></mat-icon>
                        }
                        @if (item.type === "success") {
                            <mat-icon class="hint-icon" svgIcon="simple_success_hint"></mat-icon>
                        }
                        @if (item.type === "warning") {
                            <mat-icon class="hint-icon" svgIcon="simple_warning_hint"></mat-icon>
                        }
                    </div>
                }
                <div class="notify-content-container">
                    <div class="message-container">
                        @if (item.title) {
                            <span class="t-body-text-semibold">{{ item.title }}</span>
                        }
                        @if (item.message.length) {
                            <ul class="message-list" [class.mt-8]="item.title">
                                @for (message of item.message; track message) {
                                    <li class="message-row">{{ message | addPunctuation }}</li>
                                }
                            </ul>
                        }
                        @if (item.action) {
                            <button mat-button [disableRipple]="true" (click)="onAction(item)" class="action-button">
                                <span class="t-body-text-medium">{{ item.action }}</span>
                            </button>
                        }
                    </div>
                </div>

                <div class="notify-actions-container pl-12">
                    <button class="close-icon" mat-icon-button [disableRipple]="true" (click)="onClose(index)">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
        }
    </div>
</ng-container>
